import { useEffect, useState } from 'react'

const ProgressBar = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    // 0 → 100% 한 번만 업데이트 (transition으로 부드럽게 보임)
    const timer = setTimeout(() => {
      setProgress(100)
    }, 100) // 살짝 delay 줘야 transition 적용됨

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-main transition-all duration-[10000ms] ease-linear"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}

export default ProgressBar
